import {Outlet, createFileRoute} from "@tanstack/react-router";
import {getPlatformUserDetails} from "../adgpt-tokens/-data";
import {getAdminWorkspacesWithCaching} from "../workspace/-queries";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/adgpt-trace-usage",
)({
    loader: async ({context}) => {
        const accessToken = context.authenticationStatus.accessToken;
        const [userDetails, workspaces] = await Promise.all([
            getPlatformUserDetails({
                accessToken: accessToken,
                plutoBaseUrl: `${context.intellsysBaseUrl}/sub-system/pluto`,
                queryClient: context.queryClient,
            }),
            getAdminWorkspacesWithCaching({
                accessToken: accessToken,
                intellsysBaseUrl: context.intellsysBaseUrl,
                queryClient: context.queryClient,
            }),
        ]);

        return {
            accessToken: accessToken,
            plutoBaseUrl: `${context.intellsysBaseUrl}/sub-system/pluto`,
            userDetails: userDetails,
            workspaces: workspaces,
        };
    },
    component: Outlet,
});
